import React, { useEffect, useState } from 'react';
import TableCrud from '../../components/TableCrud';
import Api, { exceptionNotificationAPI } from '../../services/api';

const AgronomistIndex = () => {
    const [isVisible, setIsVisible] = useState(false);

    const columns = [
        {
            label: "Nome",
            name: "name"
        },
        {
            label: "CREA",
            name: "crea"
        },
        {
            label: "Empresa",
            name: "tenant.name",
            visible: isVisible
        },
        {
            label: "Ativo",
            name: "isActive"
        },
    ]

    const loadData = async () => {
        Api.get('Tenant/isTenant').then((result) => {
            if (result.data.response) {
                setIsVisible(true)
            }
            else{
                setIsVisible(false)      
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
        
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <TableCrud title={"Responsável Técnico/Agrônomo"} table={"agronomist"} columns={columns}/>
    );
}

export default AgronomistIndex;
